import type { ReactNode } from 'react';

export const symbol_breakfast_dining: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M230-120q-26 0-43-17t-17-43v-367q-39-22-64.5-56.5T80-692q0-63 42.5-105.5T228-840h504q63 0 105.5 42.5T880-692q0 54-25.5 88.5T791-547v367q0 26-17 43t-43 17H230Zm0-60h501v-395l35-22q23-14 38.5-37t15.5-58q0-37-25.5-62.5T732-780H228q-37 0-62.5 25.5T140-692q0 36 15 58.5t40 37.5l35 21v395Zm229-69q10 10 21.5 10t21.5-10l170-170q10-10 10-21.5T672-462L502-632q-8-8-21.5-8t-21.5 8L289-462q-10 10-10 21.5t10 21.5l170 170Zm21-61L352-438l128-128 128 128-128 128Zm1-170Z"
		/>
	</svg>
);
